import React from 'react';
import Lottie from 'react-lottie';
import AixueFooter from '@/components/AixueFooter/index';
import AixueHeader from '@/components/AixueHeader/index';
import styles from './index.module.scss';
import starData from '@/assets/lottie/star-data.json';
import screenBackground from '@/assets/join/join-bg.png';
import joinBackgroundBottom from '@/assets/join/join-background-bottom.png';
import joinBlock1 from '@/assets/join/join-block-1.png';
import joinBlock2 from '@/assets/join/join-block-2.png';
import joinCardLeft from '@/assets/join/join-card-left.png';
import joinCardRight from '@/assets/join/join-card-right.png';
import joinCardLeftClear from '@/assets/join/join-card-clear1.png';
import joinCardRightClear from '@/assets/join/join-card-clear2.png';
import joinCardLeftBlur from '@/assets/join/join-card-left-blur.png';
import joinCardRightBlur from '@/assets/join/join-card-right-blur.png';
import joinCardTopLeft from '@/assets/join/join-card-top-whole-left.png';
import joinCardTopRight from '@/assets/join/join-card-top-whole-right.png';

const starLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: starData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export default function AixueJoin() {
  // const leftCardRef = useScreenSlideIn({
  //   triggerSlideRatio: 0.6,
  //   animationClassName: styles['card-left-slide-in'],
  //   scrollContainerSelector: null,
  //   triggerOnce: true,
  // });
  // const rightCardRef = useScreenSlideIn({
  //   triggerSlideRatio: 0.6,
  //   animationClassName: styles['card-right-slide-in'],
  //   scrollContainerSelector: null,
  //   triggerOnce: true,
  // });

  return (
    <div className={`${styles.container}`}>
      {/* 上半部分 */}
      <section
        className={styles['join-section-top']}
        style={{ '--background-url': `url(${screenBackground})` } as React.CSSProperties}
      >
        <div className={styles['join-header']}>
          <AixueHeader title="爱学" />
        </div>
        <div className={styles['join-wrap']}>
          <div className={styles['join-content']}>
            <div
              className={`wow animate__animated animate__fadeIn ${styles['join-titleBig']}`}
              style={{ animationDelay: '0.2s', animationDuration: '1.2s' }}
            >
              <div className={styles['join-title-row']}>
                加入我们
                <span className={styles['join-star-wrap']} aria-hidden>
                  <Lottie options={starLottieOptions} />
                </span>
              </div>
            </div>
            <div
              className={`wow animate__animated animate__fadeIn ${styles['join-desc']}`}
              style={{ animationDelay: '0.4s', animationDuration: '1.2s' }}
            >
              投身AI · 重塑教育
            </div>
          </div>
        </div>
      </section>

      {/* 下半部分 */}
      <section
        className={styles['join-section-bottom']}
        style={{ '--background-bottom-url': `url(${joinBackgroundBottom})` } as React.CSSProperties}
      >
        <img src={joinBlock1} alt="" className={styles['join-block-1']} />

        {/* 左右两个招聘卡片 */}
        <div className={styles['card-row']}>
          <div
            className={styles['card-left']}
            style={{ '--card-top-url': `url(${joinCardTopLeft})` } as React.CSSProperties}
            role="button"
            tabIndex={0}
            onClick={() =>
              window.open(
                'https://app.mokahr.com/social-recruitment/yuaiweiwu/145289?locale=zh-CN',
                '_blank',
                'noopener,noreferrer',
              )
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                window.open(
                  'https://app.mokahr.com/social-recruitment/yuaiweiwu/145289?locale=zh-CN',
                  '_blank',
                  'noopener,noreferrer',
                );
              }
            }}
          >
            <div className={styles['card-bg-left']}>
              <div
                className={`${styles['card-bg-layer']} ${styles['card-bg-layer-default']}`}
                aria-hidden
                style={{ backgroundImage: `url(${joinCardLeft})` }}
              />
              <div
                className={`${styles['card-bg-layer']} ${styles['card-bg-layer-clear']}`}
                aria-hidden
                style={{ backgroundImage: `url(${joinCardLeftClear})` }}
              />
              <div
                className={`${styles['card-bg-layer']} ${styles['card-bg-layer-blur']}`}
                aria-hidden
                style={{ backgroundImage: `url(${joinCardLeftBlur})` }}
              />
              <div className={styles['card-text']}>
                <div className={styles['card-text-title']}>社会招聘</div>
                <div className={styles['card-text-desc']}>Social recruitment</div>
              </div>
            </div>

            <div className={styles['card-top-left']} />

            <div className={styles['card-top-text-container']}>
              <div className={styles['card-top-text']}>
                <div className={styles['card-top-text-title']}>社会招聘</div>
                <div className={styles['card-top-text-desc']}>Social recruitment</div>
              </div>
            </div>
          </div>

          <div
            className={styles['card-right']}
            style={{ '--card-top-url': `url(${joinCardTopRight})` } as React.CSSProperties}
            role="button"
            tabIndex={0}
            onClick={() =>
              window.open(
                'https://app.mokahr.com/campus-recruitment/yuaiweiwu/145290?locale=zh-CN',
                '_blank',
                'noopener,noreferrer',
              )
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                window.open(
                  'https://app.mokahr.com/campus-recruitment/yuaiweiwu/145290?locale=zh-CN',
                  '_blank',
                  'noopener,noreferrer',
                );
              }
            }}
          >
            <div className={styles['card-bg-right']}>
              <div
                className={`${styles['card-bg-layer']} ${styles['card-bg-layer-default']}`}
                aria-hidden
                style={{ backgroundImage: `url(${joinCardRight})` }}
              />
              <div
                className={`${styles['card-bg-layer']} ${styles['card-bg-layer-clear']}`}
                aria-hidden
                style={{ backgroundImage: `url(${joinCardRightClear})` }}
              />
              <div
                className={`${styles['card-bg-layer']} ${styles['card-bg-layer-blur']}`}
                aria-hidden
                style={{ backgroundImage: `url(${joinCardRightBlur})` }}
              />
              <div className={styles['card-text']}>
                <div className={styles['card-text-title']}>校园招聘</div>
                <div className={styles['card-text-desc']}>Campus recruitment</div>
              </div>
            </div>

            <div className={styles['card-top-right']} />

            <div className={styles['card-top-text-container']}>
              <div className={styles['card-top-text']}>
                <div className={styles['card-top-text-title']}>校园招聘</div>
                <div className={styles['card-top-text-desc']}>Campus recruitment</div>
              </div>
            </div>
          </div>
        </div>

        <img src={joinBlock2} alt="" className={styles['join-block-2']} />
      </section>
      <div className={styles['footer-snap']}>
        <AixueFooter />
      </div>
    </div>
  );
}
